import { useState } from "react";
import FAQCard from "./FAQCard";


const faqData = [
  {
    question: "How do I search for properties on AlkinaRealty?",
    answer:
      "Learn how to use our user-friendly search tools to find properties that match your criteria.",
  },
  {
    question: "What documents do I need to sell my property through AlkinaRealty?",
    answer:
      "Find out about the necessary documentation for listing your property with us.",
  },
  {
    question: "How can I contact an AlkinaRealty agent?",
    answer:
      "Discover the different ways you can get in touch with our experienced agents.",
  },
];

export default function FAQSection() {
  const [currentPage] = useState(1);
  const totalPages = 10;

  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-6xl mx-auto flex flex-col gap-8 md:gap-12">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-start md:items-end gap-4 md:gap-8 lg:gap-12 w-full ml-2">
          <div className="flex flex-col items-start gap-2 flex-1 relative">
            <h2 className="text-primary font-semibold text-2xl md:text-3xl lg:text-4xl leading-[150%] w-full">
              Frequently Asked Questions
            </h2>
            <p className="text-black font-medium text-sm md:text-base leading-[150%] w-full">
              Find answers to common questions about AlkinaRealty's services, property
              listings, and the real estate process. We're here to provide clarity
              and assist you every step of the way.
            </p>

          </div>
          <button className="flex px-4 py-2.5 items-center gap-2 border border-gray-300 bg-primary text-tertiary font-medium text-sm leading-[150%] transition-colors whitespace-nowrap">
            <span>View All FAQ's</span>
          </button>
        </div>

        {/* FAQ Cards and Pagination */}
        <div className="flex flex-col items-start gap-6 md:gap-8 w-full">
          {/* Cards Container */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 w-full">
            {faqData.map((faq, index) => (
              <FAQCard
                key={index}
                question={faq.question}
                answer={faq.answer}
              />
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-between items-center w-full pt-4 border-t border-gray-300">
            <div className="text-black font-medium text-sm md:text-base leading-[150%]">
              <span className="text-primary">{String(currentPage).padStart(2, "0")}</span>
              <span> of {totalPages}</span>
            </div>
            <div className="flex items-center gap-2.5">
              {/* Previous Button */}
              <button
                className="flex p-1.5 md:p-2.5 items-center gap-2.5 border border-gray-300 bg-gray-100 hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={currentPage === 1}
              >
                <svg
                  className="w-4 h-4 md:w-6 md:h-6"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.5 15C25.5 15.6213 24.9963 16.125 24.375 16.125L8.41812 16.125L14.6547 22.0641C15.1026 22.4947 15.1166 23.2069 14.6859 23.6548C14.2553 24.1026 13.5431 24.1166 13.0953 23.6859L4.84525 15.8109C4.62466 15.5988 4.5 15.306 4.5 15C4.5 14.694 4.62466 14.4012 4.84525 14.1891L13.0953 6.31406C13.5431 5.88342 14.2553 5.89739 14.6859 6.34525C15.1166 6.79312 15.1026 7.5053 14.6547 7.93594L8.41812 13.875L24.375 13.875C24.9963 13.875 25.5 14.3787 25.5 15Z"
                    fill="#666666"
                  />
                </svg>
              </button>
              {/* Next Button */}
              <button className="flex p-1.5 md:p-2.5 items-center gap-2.5 border border-gray-300 bg-gray-100 hover:bg-gray-200 transition-colors">
                <svg
                  className="w-4 h-4 md:w-6 md:h-6"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 15C4.5 14.3787 5.00368 13.875 5.625 13.875L21.5819 13.875L15.3453 7.93593C14.8974 7.50529 14.8834 6.79312 15.3141 6.34525C15.7447 5.89738 16.4569 5.88342 16.9047 6.31406L25.1547 14.1891C25.3753 14.4012 25.5 14.694 25.5 15C25.5 15.306 25.3753 15.5988 25.1547 15.8109L16.9047 23.6859C16.4569 24.1166 15.7447 24.1026 15.3141 23.6547C14.8834 23.2069 14.8974 22.4947 15.3453 22.0641L21.5819 16.125L5.625 16.125C5.00368 16.125 4.5 15.6213 4.5 15Z"
                    fill="#333333"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


